import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useSelector } from "react-redux";

const useStylesForSpinner = makeStyles((theme) => ({
  root: {
    position: "relative",
    color: "red",
  },

  top: {
    color: "#1a90ff",
    animationDuration: "550ms",
    left: 0,
  },
  circle: {
    strokeLinecap: "round",
    background: "red",
    color: "#231F20",
  },
}));

export const UiMainLoader = (props) => {
  const classes = useStylesForSpinner();
  const loader = useSelector((state) => state.loading);

  return (
    <>
      {loader?.show ? (
        <div className="df-backdrop-loader">
          {props.inverted ? (
            <div className="df-inverted">
              <CircularProgress
                variant="indeterminate"
                className={classes.top}
                classes={{
                  circle: classes.circle,
                }}
                size={props.loaderSize}
                thickness={props.loaderThickness}
              />
              {props.backdropMessage && (
                <p className="df-backdrop-loader__message">
                  {props.backdropMessage}
                </p>
              )}
            </div>
          ) : (
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={props.loaderSize}
              thickness={props.loaderThickness}
            />
          )}
        </div>
      ) : null}
    </>
  );
};
